import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'
import moment from 'moment'

import { dirtyRead, doc } from 'selectors/common'

const colors = {
	'Application': 'white'
  , 'Contract': 'rgb(133,228,133)'
  , 'Contract renewal': 'rgb(133,228,133)'
  , 'Contract break': 'rgb(228,133,133)'
  , 'Move in': 'rgb(133,228,133)'
  , 'Move out': 'rgb(228,133,133)'
  , 'Listing': 'white'
  , 'Task': 'yellow'
  , 'No payment': 'rgb(228,133,133)'
  , 'Late payment': 'yellow'
  , 'Comment': 'yellow'
}

export default class EventCard extends Component {
	render(){
			return(
					<ListItem
						style={{
							overflow: 'hidden'
						  , paddingLeft: "0"
						  , marginLeft: "0"
						  , margin: "0"
						  , textOverflow: "ellipsis"
						  , cursor: "pointer"
						  , width: "100%"
						}}
						hoverColor="none"
						innerDivStyle={{
							padding: "0px"
						}}
					>
						<div style={{
							width: "100%"
						  , padding: "15px 0"
						  , display: "flex"
						  , justifyContent: 'space-between'
						  , color:(this.props.event.dateFormat && moment(new Date(this.props.event.dateFormat)).format('YYYY-MM-DD')>moment(new Date(this.props.currentDate)).format('YYYY-MM-DD')) || this.props.retired ? "rgb(200,200,200)" : "black"}}
						>
							<div
								style={{
									fontSize: "16px"
								  , width: "60%"
								  , textAlign:"left"
								  , whiteSpace: "nowrap"
								  , overflow: "hidden"
								  , textOverflow: "ellipsis"
								}}
							>
									{this.props.event.type!="Task" && <span>{this.props.event.type}</span>}
									{this.props.event.type=="Task" && <span>{this.props.event.name}</span>}
							</div>
							<div
								style={{
									fontSize: "16px"
								  , width: "15%"
								  , textAlign:"center"
								  , whiteSpace: "nowrap"
								  , paddingRight: "5px"
								  , margin: "0 15px"
								}}
							>
								  	{this.props.event.date}
							</div>

							<div
								style={{
									fontSize: "16px"
								  , overflow: "hidden"
								  , boxSizing: "borderBox"
								  , textAlign: "right"
								  , width:"15%"
								  , whiteSpace: "nowrap"
								  , textOverflow: "ellipsis"
								}}
							>
									{this.props.event.description}
							</div>
						</div>
					</ListItem>
			)
	}

}



// WEBPACK FOOTER //
// ./src/components/Communication/events/Card.js